import axios from 'axios'

export default {
  list(params) {
    return axios.get('/features', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  get(id) {
    return axios.get('/features/' + id).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  save(data) {
    return axios.post('/features', data).then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
}
